import { LanguageType } from "@/custom-types";
import { IncidentTypeOption } from "@/graphql/generated";

export const incidentTypeMapper = (type: IncidentTypeOption, language: LanguageType) => {
  const texts = {
    en: {
      FAULT: 'Fault',
      MAINTENANCE: 'Maintenance',
    },
    es: {
      FAULT: 'Falla',
      MAINTENANCE: 'Mantenimiento',
    }
  }

  return texts[language][type]
}